export default function () {
  if (window.mixpanel) {
    if (window.__BOWER__.customer) {
      window.mixpanel.identify(window.__BOWER__.customer.id)
      window.mixpanel.people.set({
        $first_name: window.__BOWER__.customer.firstName,
        $last_name: window.__BOWER__.customer.lastName,
        $email: window.__BOWER__.customer.email,
        shopify_id: window.__BOWER__.customer.id,
      })
    }
    window.mixpanel.track('page_view')
  }
}
